<template>
    <div class="slm-history-map__result-info">
        <div class="slm-history-map__result-info--filters">
            <button class="slm-history-map__result-info--remove" :class="filter.type" v-for="filter in filters" :key="filter.value" @click="removeFilter(filter)">
                <span class="show-for-sr">Ta bort filter:</span>
                <span v-if="filter.icon" class="slm-history-map__result-info--remove__icon" v-html="icon ? getIcon(icon, filter.color) : ''"></span>
                {{filter.title}}
                <span v-if="filter.icon" class="slm-history-map__result-info--remove__icon"></span>
            </button>
            <button v-if="filters.length" class="slm-history-map__result-info--remove-all" @click="resetFilter()">
                Rensa filter
            </button>
        </div>
        <!-- <p class="slm-history-map__result-info--text">
            I kartan visas 
            <span class="slm-history-map__result-info--text__bold">
                {{histories.length}} x
            </span>
        </p> -->
    </div>
</template>

<script>
export default {
    name: 'result-info-component',
    computed: {
        histories() {
            return this.$store.state.filteredHistories
        },
        filters() {
            return this.$store.getters.selectedFilters;
        },
        icon() {
            return this.$store.state.icon;
        },
    },
    methods: {
        removeFilter(filter) {
            this.$store.commit('removeFilter', filter);
            setTimeout(() => {
                this.$store.commit('setFilteredHistories');
                this.$store.commit('setFiltersChanged');
                this.$store.dispatch('setUrl');
            }, 50)
        },
        resetFilter() {
            this.$store.commit('resetAllFilters');
            setTimeout(() => {
                this.$store.commit('setFilteredHistories');
                this.$store.commit('setFiltersChanged');
                this.$store.dispatch('setUrl');
            }, 50)
        },
        getIcon(svgString, colorString) {
            return svgString.replace('fill="#fff"', 'fill="' + colorString + '"');
        }
    }
}
</script>